import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_CONFIG, NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { dagKeys } from '@/shared/lib/query/queryKeys';

import { deleteDagApi } from '@/entities/dag/api/deleteDagApi';
import type { DeleteDagRequest } from '@/entities/dag/domain/types';

export const useDeleteDagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteDagRequest>({
    mutationFn: (request) => deleteDagApi(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: dagKeys.all });

      notification.success({
        message: NOTIFICATION_MESSAGES.DAG_DELETE_SUCCESS,
        description: NOTIFICATION_MESSAGES.DAG_DELETE_SUCCESS_DESC,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.SUCCESS,
      });
    },
    onError: (error) => {
      console.error('Failed to delete DAG:', error);

      notification.error({
        message: NOTIFICATION_MESSAGES.DAG_DELETE_ERROR,
        description: NOTIFICATION_MESSAGES.DAG_DELETE_ERROR_DESC,
        placement: NOTIFICATION_CONFIG.PLACEMENT,
        duration: NOTIFICATION_CONFIG.DURATION.ERROR,
      });
    },
  });
};
